import { create } from "zustand";

interface ZowieStore {
  bottom: number;
  setBottom: (value: number) => void;
}

export const useZowiePositionStore = create<ZowieStore>((set) => ({
  bottom: 0,
  setBottom: (value) => set(() => ({ bottom: value })),
}));
